import Languages from './languages'


export default Languages['pt-BR']
